module.exports = __webpack_public_path__ + "img/DSC_2003.a0318881.JPG";